import 'react-block-ui/style.css'
import './styles.scss'

import React   from 'react'
import BlockUi from 'react-block-ui'
import Payment from 'payment'

import { Modal, message, notification } from 'antd'
import prettysize  from '../../../utils'

import { bindActionCreators } from 'redux'
import { connect }            from 'react-redux'
import { withRouter }         from 'react-router-dom'

import CloudFlyerAPI                    from '../../../api/CloudFlyerAPI'
import {local_refresh}               from '../../../actions/file-catalyst-actions'
import { local_selection_changed }   from '../../../actions/file-catalyst-actions'
import { refresh_profile }           from '../../../actions/auth'
import { on_top_notification_changed} from '../../../actions/content-alert-actions'

import Header              from '../../Fs/Controls/header'
import NavigationControls  from './navigation-controls'
import CreateFolder        from '../../Fs/Controls/create-folder'
import Files               from './files'

import PaymentForm         from '../../Billing/PaymentForm'

class LocalFiles extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      files              : [],
      files_loading      : false,

      previous_path      : null,
      current_path       : '/',

      is_transfer_agent_running : false,

      create_folder      : false,
      new_folder_name    : '',

      files_error        : null,
      new_folder_error   : null,
      delete_error       : null,

      new_folder_loading : false,
      transfer_loading   : false,

      selection : {
        size       : 0,
        cost       : 0.0003,
        total_cost : 0,
        count      : 0
      },

      billing_modal_visible : false,
      billing_loading       : false,
      billing_valid         : false,
      billing :{
        number: '',
        name: '',
        exp: '',
        cvc: ''
      }
    }
  }

  componentDidMount() {
    if(this.props.is_transfer_agent_running){
      this.on_refresh()
    }

    //"Hi user, in order to use CloudFlyer File Accelerator for up to 10G speeds, you will need to submit your billing information."
    //"Hi USER FIRST NAME, in order to use CloudFlyer File Accelerator for up to 10G speeds, you will need to submit your billing information."
    /*let $this = this
    if($this.props.user){
      const {first_name, last_name, has_billing_info, quota = {}} = $this.props.user

      if(!has_billing_info && quota.fc <= FC_QUOTA_WARNING_SIZE){
        const message = "Hey " + first_name + ' ' + last_name + ", we noticed you didn’t set up a payment method, we need you to sort it out before handling your files :)"
        $this.setState({ billing_alert : true })
        $this.props.on_top_notification_changed(message, ()=> {$this.setState({ billing_modal_visible: true })}, 'Set payment method')
      }
    }*/
  }

  componentWillUnmount() {
    if(this.state.billing_alert){
      this.props.on_top_notification_changed()
    }
  }

  componentWillReceiveProps(props) {
    let should_refresh = !this.state.is_transfer_agent_running &&  props.is_transfer_agent_running

    this.setState({
      create_folder : props.create_folder,
      current_path  : props.current_path,
      previous_path : props.previous_path,
      files         : (props.files_loading ? this.state.files : props.files), //.sort(Utils.sortBy('isFile')),
      files_loading : props.files_loading,
      files_error   : props.files_error,
      is_transfer_agent_running : props.is_transfer_agent_running
    }, ()=> should_refresh ? this.props.local_refresh(this.state) : null)
  }

  on_refresh = () =>{
    if(!this.props.is_transfer_agent_running){
      return message.warn('Please launch the transfer agent first')
    }

    this.props.local_refresh(this.state)
  }

  on_upload = files =>{
    let $this  = this

    if(!this.state.is_transfer_agent_running){
      return message.warn('Please launch the transfer agent before downloading!')
    }

    if(this.state.transfer_server_error){
      return notification.warn('Error connecting to the transfer server')
    }

    if(!files){
      files = $this.state.files.filter((f)=> f.checked)
    }

    if(files.length === 0){
      return
    }

    let total_size = files.map(f => f.size).reduce((prev, curr) => prev + curr)
    let {quota : {fc:{trial={}}}={}, has_billing_info, role={}} = $this.props.user

    if(!has_billing_info && total_size > (trial.total - trial.used)){
      if(role.title !== 'Owner'){
        return Modal.warning({
          title:'Transfers Quota Limit',
          content:(
            <div>
              <p>Please contact account owner to add Credit Card information to your organization.</p>
              <p>You have {prettysize(trial.total - trial.used)} remaining on your quota.</p>
            </div>
          ),
          onOk:()=> {
            $this.props.refresh_profile(true)
          }
        })
      }
      return this.setState({
        billing_modal_visible:true}, ()=>{
        if(document.querySelector('[name="number"]')){
          //Payment.formatCardNumber(document.querySelector('[name="number"]'))
          /*Payment.formatCardExpiry(document.querySelector('[name="expiry"]'))*/
          Payment.formatCardCVC(document.querySelector('[name="cvc"]'))
        }
      })
    }

    $this.setState({transfer_loading : true})
    CloudFlyerAPI.file_catalyst
      .transfers
      .upload(files.map((f)=> f.path),
        $this.props.remote_directory,
        $this.props.connection_key,
        $this.props.user.id)
      .then(() =>{
        $this.setState({transfer_loading : false})
      })
      .catch(e =>{
        $this.setState({
          transfer_loading : false
        })

        console.info('Upload: error')
        console.error(e)
      })
  }

  on_delete = file =>{
    let $this = this

    let file_names = []

    if(file && !file.checked){
      file_names.push(file.path)
    } else {
      for (let i = 0; i < this.state.files.length; i++) {
        let fl = this.state.files[i];
        if(fl.checked){
          file_names.push(fl.path)
        }
      }
    }

    $this.setState({
      delete_loading: true
    })

    CloudFlyerAPI.file_catalyst
      .files
      .delete_file(file_names[0])
      .then(() =>{
        $this.setState({
          delete_loading : false
        }, ()=> $this.on_refresh())
      })
      .catch(e =>{
        $this.setState({delete_loading:false, delete_error : e})
        message.error(e.message)
      })
  }

  on_navigate_back = () =>{
    this.setState({current_path : this.state.previous_path}, ()=> this.on_refresh())
  }

  on_navigate = file =>{
    this.setState({current_path : file.path}, ()=> this.on_refresh())
  }

  on_select = (file, checked) =>{
    for (let key in this.state.files) {
      let item = this.state.files[key]
      if(item.path === file.path){
        item.checked = checked
        this.setState({
          files : this.state.files
        }, ()=> this.props.local_selection_changed(this.calculate_selection()))
        return
      }
    }
  }

  on_search = term =>{}

  on_create_folder = new_folder_name => {
    let $this = this

    if(!new_folder_name){
      return this.setState({
        create_folder : true
      })
    }

    this.setState({
      new_folder_loading : true
    })

    CloudFlyerAPI.file_catalyst
      .files
      .create_directory(this.state.current_path + '/' + new_folder_name)
      .then(() =>{
        $this.setState({
          new_folder_loading : false,
          create_folder : false
        }, ()=> $this.on_refresh())
      })
      .catch(e =>{
        console.error(e)
        $this.setState({new_folder_loading:false, new_folder_error : e})
        message.error(e.message)
      })
  }

  on_cancel_create_folder = () => {
    return this.setState({
      create_folder : false
    })
  }

  on_new_folder_name_change = new_folder_name => {
    this.setState({ new_folder_name: new_folder_name });
  }

  calculate_selection = () => {
    let files = this.state.files.filter((f) => f.isFile && f.checked)
    let selection = {
      size       : 0,
      cost       : 0.0003,
      total_cost : 0,
      count      : 0
    }

    for (let key in files) {
      let file = files[key]

      selection.size       += file.size
      selection.count      += 1
      selection.total_cost += selection.cost * (file.size/(1024*1024*1024))
    }

    this.setState({
      selection: selection
    })
    return selection
  }

  on_focus = target => {
    this.setState({
      focused: target.name,
    })
  }

  on_billing_change = target => {
    const billing = this.state.billing

    if (target.name === 'number') {
      billing[target.name] = target.value.replace(/ /g, '')
    }
    else if (target.name === 'expiry') {
      billing[target.name] = target.value.replace(/[ \/]/g, '')
    }
    else {
      billing[target.name] = target.value
    }

    this.setState({
      billing: billing
    })
  }

  billing_callback = (type, isValid) => {
    this.setState({billing_valid : isValid})
  }

  on_cancel_billing = () => {
    this.setState({ billing_modal_visible: false });
  }

  on_save_billing = () => {
    let $this  = this
    $this.form.validateFields((err, values) => {
      if (err) {
        return message.error('Please fill required fields')
      }

      $this.setState({billing_loading: true})

      const { name, number, expiry, cvc } = values
      let {email, first_name, last_name} = $this.props.user

      let subscription = {
        customer_subscription: {
          subscription: {
            product_handle : 'CloudFlyer-free',
            coupon_code    : '',

            customer_attributes: {
              first_name : first_name,
              last_name  : last_name,
              email      : email
            },

            credit_card_attributes: {
              full_number      : number,
              expiration_month : expiry.split('/')[0],
              expiration_year  : expiry.split('/')[1],
              billing_address  : '',
              billing_city     : '',
              billing_state    : '',
              billing_country  : 'USA',
              billing_zip      : ''
            }
          }
        }
      }

      CloudFlyerAPI.billing.subscriptions
        .new_customer(subscription)
        .then(()=> {
          $this.setState({billing_loading: false, billing_modal_visible:false}, ()=>{
            $this.props.refresh_profile(true)
            message.success('Subscribed successfully')
          })
        })
        .catch(function (err) {
          $this.setState({billing_loading: false}, ()=> $this.props.refresh_profile(true))

          if(((err.response||{}).data||{})){
            if(((err.response||{}).data||{}).chargify_errors){
              return message.error(((err.response||{}).data||{}).chargify_errors[0])
            }
            message.error(((err.response||{}).data||{}).message)
          } else {
            message.error(err.message)
          }
        })
    })
    $this.props.refresh_profile(true)
  }

  save_ref = form => {
    this.form = form;
  }

  render() {
    const {transfer_loading, files_loading, billing_modal_visible, focused, billing_loading} = this.state
    const { name, number, expiry, cvc } = this.state.billing
    const {is_transfer_agent_running, on_launch_transfer_agent, launch_loading} = this.props

    return (
      <BlockUi className='files-system' blocking={transfer_loading || files_loading}>

        <Header title={'Local File System'} on_search={this.on_search.bind(this)}/>

        <hr/>

        <NavigationControls
          key              = {'NavigationControls'}
          files_loading    = {this.state.files_loading}
          previous_path    = {this.state.previous_path}
          files            = {this.state.files}
          on_navigate_back = {this.on_navigate_back.bind(this)}
          on_delete        = {this.on_delete.bind(this)}
          on_create_folder = {this.on_create_folder.bind(this)}
          on_refresh       = {this.on_refresh.bind(this)}
          on_upload        = {this.on_upload.bind(this)}
        />

        <hr/>

        {this.state.create_folder ? ([<CreateFolder key={'CreateFolder'}
                                                    new_folder_name  = {this.state.new_folder_name}
                                                    on_create_folder = {this.on_create_folder.bind(this)}
                                                    on_change        = {this.on_new_folder_name_change.bind(this)}
                                                    on_cancel        = {this.on_cancel_create_folder.bind(this)}/>, <hr key={'hr'}/>])  : null}

        <Files
          key           = {'Files'}
          files         = {this.state.files}
          files_loading = {files_loading || launch_loading}
          is_transfer_agent_running = {is_transfer_agent_running}
          on_delete     = {this.on_delete.bind(this)}
          on_select     = {this.on_select.bind(this)}
          on_refresh    = {this.on_refresh.bind(this)}
          on_navigate   = {this.on_navigate.bind(this)}
          on_upload     = {this.on_upload.bind(this)}
          on_launch_transfer_agent = {on_launch_transfer_agent}
        />

        <PaymentForm title   = {''}
                     ref     = {this.save_ref.bind(this)}
                     visible = {billing_modal_visible}
                     loading = {billing_loading}

                     name    = {name}
                     number  = {number}
                     expiry  = {expiry||'##/##'}
                     cvc     = {cvc}
                     focused = {focused}

                     on_cancel = {this.on_cancel_billing.bind(this)}
                     on_save   = {this.on_save_billing.bind(this)}
                     on_focus  = {this.on_focus.bind(this)}
                     on_change = {this.on_billing_change.bind(this)}
                     callback  = {this.billing_callback.bind(this)}
        />
      </BlockUi>
    )
  }
}

export default withRouter(connect(({auth, fileCatalyst, cloudFilesSystem }) => {
  let current_path = ''
  if(cloudFilesSystem && cloudFilesSystem.current_path && typeof cloudFilesSystem.current_path === 'string'){
    if(cloudFilesSystem.current_path.startsWith('/')){
      current_path = cloudFilesSystem.current_path
    } else {
      current_path = '/' + cloudFilesSystem.current_path
    }
  }

  let remote_directory = (cloudFilesSystem && cloudFilesSystem.bucket)? (cloudFilesSystem.bucket.bucket_name + current_path) : ''
  return {
    ...fileCatalyst,
    user : auth.user,
    remote_directory
  }
}, (dispatch) => bindActionCreators({local_refresh, local_selection_changed, refresh_profile: refresh_profile, on_top_notification_changed}, dispatch))(LocalFiles))

